/** Default homepage / global SEO: keep in sync with index.html and lib/og-meta.cjs */
export const SITE_HOME_TITLE =
  "Wave of Innovation | XRP events";

export const SITE_HOME_DESCRIPTION =
  "Wave of Innovation is an independent non-profit events and media organisation that runs XRP Ledger events across the UK and APAC, connecting institutions, builders, and communities.";

export const SITE_HOME_KEYWORDS =
  "Wave of Innovation, XRP Ledger, XRPL, UK, APAC, London, Sydney, XRP events, conferences, institutions, builders, fintech";
